import RestService from '../services/rest';

async function getProducts(limit, skip) {
  return RestService.getAuthenticated(`panel/products?limit=${limit}&skip=${skip}`);
}

async function searchProductsCheckbuy(limit, search) {
  return RestService.getAuthenticated(`products/search/checkbuy?limit=${limit}&search=${search}`);
}

async function searchProductsCheckbuyTelecom(limit, search) {
  return RestService.getAuthenticated(`products/search/checkbuy/telecom?limit=${limit}&search=${search}`);
}

async function getCount() {
  return RestService.getAuthenticated('panel/products/count');
}

async function getSearchProducts(limit, search) {
  return RestService.getAuthenticated(`panel/products/search?limit=${limit}&search=${search}`);
}

async function getSearchPanelProducts(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/products?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function updateProductSpotlight(soneparId, spotlight) {
  return RestService.putAuthenticated('panel/products/update', { soneparId, spotlight: !!spotlight });
}

async function updateProductIsSpot(soneparId, isSpot) {
  return RestService.putAuthenticated('panel/products/update', { soneparId, isSpot: !!isSpot });
}

async function updateProductIsDisable(soneparId, isDisable) {
  return RestService.putAuthenticated('panel/products/update', { soneparId, isDisable: !!isDisable });
}

async function updateProduct(product) {
  return RestService.putAuthenticated('panel/products/update', product);
}

async function saveProduct({
  soneparId, spotlight, isSpot, categoryId, brandId, description, code, brandTectag, otherBrand, otherDescription,
  descriptionTectag,
}) {
  return RestService.postAuthenticated('panel/products/create', {
    soneparId,
    spotlight,
    isSpot,
    categoryId,
    brandId,
    description,
    code,
    brandTectag,
    otherBrand,
    otherDescription,
    descriptionTectag,
  });
}

async function deleteProduct(soneparId) {
  return RestService.postAuthenticated('panel/products/remove', {
    soneparId,
  });
}

async function getCsvProductModel() {
  const response = await RestService.getAuthenticated('panel/products/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Produtos CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvProductsReport() {
  const response = await RestService.getAuthenticated('panel/products/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'products-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvProducts(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/products/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function disableProductsByCategory(categoryId) {
  return RestService.putAuthenticated(`panel/products/disableByCategory?category=${categoryId}`);
}

export default {
  getProducts,
  getSearchPanelProducts,
  searchProductsCheckbuy,
  searchProductsCheckbuyTelecom,
  getCount,
  getSearchProducts,
  saveProduct,
  updateProductSpotlight,
  updateProductIsSpot,
  updateProductIsDisable,
  updateProduct,
  deleteProduct,
  uploadCsvProducts,
  getCsvProductModel,
  getCsvProductsReport,
  disableProductsByCategory,
};
